import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { merge, Subscription, timer } from 'rxjs';
import { isAfter, isBefore } from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class UnderMaintenanceService implements OnDestroy {

  active = false;
  from: Date;
  until: Date;
  private subscription: Subscription;

  constructor(private router: Router) {}

  activate(from: Date, fromRoute: string, until: Date, untilRoute: string, activeCallback?: () => void, inactiveCallback?: () => void) {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = new Subscription();

    this.from = from;
    this.until = until;

    if (!isAfter(new Date, until)) {
      this.subscription.add(
        merge(
          timer(from),
          timer(until)
        ).subscribe(_ => {
          const current = new Date();
          if (isAfter(current, from) && isBefore(current, until)) {
            this.active = true;
            if (activeCallback) {activeCallback();}
            this.router.navigateByUrl(fromRoute);
          }
          if (isAfter(current, until)) {
            this.active = false;
            if (inactiveCallback) {inactiveCallback();}
            this.router.navigateByUrl(untilRoute);
          }
        })
      );
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
